import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './utils/firebase';
import User from './pages/User';
import Community from './pages/community_page';
import Landing from './pages/landing';
import Login from './pages/login';
import Signup from './pages/signup';
import VerifyEmail from './pages/verifyemail';
import Account from './pages/account';
import StatsPage from './pages/StatsPage';
import { ToastProvider } from './context/ToastContext';

function App() {
  // Global auth state — resolves once on mount, blocks all routing until ready.
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser ?? null);
    });
    return unsubscribe;
  }, []);

  // Block everything until auth resolves — no flash of landing/login.
  if (user === undefined) {
    return (
      <div className="App" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <p className="loading">Loading...</p>
      </div>
    );
  }

  const isAuthed = !!user;

  return (
    <ToastProvider>
      <Router>
        <Routes>
          {/* Public routes — redirect to /user if already authenticated */}
          <Route path="/" element={isAuthed ? <Navigate to="/user" replace /> : <Landing />} />
          <Route path="/login" element={isAuthed ? <Navigate to="/user" replace /> : <Login />} />
          <Route path="/signup" element={isAuthed ? <Navigate to="/user" replace /> : <Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Private routes — redirect to /login if not authenticated */}
          <Route path="/user" element={isAuthed ? <User /> : <Navigate to="/login" replace />} />
          <Route path="/community" element={isAuthed ? <Community /> : <Navigate to="/login" replace />} />
          <Route path="/stats" element={isAuthed ? <StatsPage /> : <Navigate to="/login" replace />} />
          <Route path="/account" element={isAuthed ? <Account /> : <Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
